


export default Text = ( { text } ) => <h2 data-aos='fade-up' className='no-results'>{text}</h2>